import React from 'react';

import { rem } from '../util';
import { Stack } from './stack';
import { H2 } from './text';

export const ErrorScreen = (
  props: React.PropsWithChildren<{ title: string }>,
) => {
  return (
    <Stack
      direction="column"
      spacing={24}
      css={{
        padding: rem(32),
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <H2 dangerouslySetInnerHTML={{ __html: props.title }} />
      {props.children}
    </Stack>
  );
};
